export default "__VITE_ASSET__jDshY5Mi__"